import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

function Header({size}) {
  return (
    <div className='header'>
        <h2 onClick={()=> window.scroll(0, 0)} className='title'>Electro <span className='magnet'>Magnet</span></h2>

        <div className='pages'>
            <Link to={'/'} className='sections'><a><h5>Home</h5></a></Link>
    
            <Link to={'/'} className='sections'><a><h5>Products</h5></a></Link>

            <Link to={'/'} className='sections'><a><h5>Featured</h5></a></Link>

            <Link to={'/cart'} className='sections'><a>Cart &nbsp;<img  className='cartlogo' src='https://i.postimg.cc/jjfd9jjg/cart.png'/></a><span style={{fontSize:"14px" , color:"orange"}}>{size}</span></Link>

        </div>



    </div>
  )
}

export default Header